module.exports = __webpack_public_path__ + "static/back1-7cf3c486c2493950dc4c324cce8a56bb.png";